import { CanvasContext } from '@cog/ecs-canvas-2d-plugin'

import { Physics, Transform } from '../Components/Common'
import { Ball } from '../Components/Tags'


export const integrate = (ctx: CanvasContext, [transform, physics]: [Transform, Physics, Ball]) => {
  const dt = ctx.timer.delta
  transform.position = transform.position.addScaled(physics.velocity, physics.speed * dt)
}